import { EventDispatcher } from "../events/EventDispatcher";
export class SoundChannel extends EventDispatcher {
    constructor() {
        super(...arguments);
        this.isStopped = false;
    }
    get volume() {
        return 1;
    }
    set volume(v) {
    }
    get position() {
        return 0;
    }
    get duration() {
        return 0;
    }
    play() {
    }
    stop() {
        if (this.completeHandler)
            this.completeHandler.runWith(false);
    }
    pause() {
    }
    resume() {
    }
    __runComplete(handler) {
        if (handler) {
            handler.runWith(true);
        }
    }
}
